import { NotificationService } from "@cradua/core";
import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  first,
  withLatestFrom,
  switchMap,
} from "rxjs/operators";
import { of } from "rxjs";
import * as AdrActions from "./adr.actions";
import {
  AdrStoreSelectors,
  AdrStoreReducer,
} from "./index";
import { select, Store } from "@ngrx/store";
import { AdrService } from "../../service/adr-progress.service";

@Injectable()
export class AdrEffects {
  loadAdr$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdrActions.loadAdr),
      exhaustMap((_) =>
        this.adrService.getAdr().pipe(
          map((data) =>
            AdrActions.loadAdrSuccess({
              Adr: data,
            })
          ),
          catchError((error) =>
            of(
              AdrActions.loadAdrFailure({
                error,
              }),
            )
          ),
        )
      ),
    )
  );


  clearAdr$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AdrActions.clearAdr),
    exhaustMap((_) => of(AdrActions.loadAdrSuccess({
            Adr: [],
          }))))
);

  fetchAdrRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdrActions.fetchAdrRecord),
      switchMap(({ fetch }) =>
        of(fetch).pipe(
          withLatestFrom(
            this.store.select(AdrStoreSelectors.getAllAdr),
          ),
        )
      ),
      switchMap(([result, res]) => {
        // console.log("result ", res);
        return this.adrService.fetchAdr(result).pipe(
          map((data) =>
            AdrActions.fetchAdrRecordSuccess({ record: data })
          ),
          catchError((error) => {
            this.notification.error(error.error.message);
            return of(
              AdrActions.fetchAdrRecordFailure({ error }),
            );
          }),
        );
      }),
    )
  );

  fetchByIdAdrRecord$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AdrActions.fetchByIdAdrRecord),
    switchMap(({ id }) =>
      of(id).pipe(
        withLatestFrom(
          this.store.select(AdrStoreSelectors.getAllAdr),
        ),
      )
    ),
    switchMap(([result, res]) => {
      // console.log("result ", res);
      return this.adrService.fetchByIdAdr(result).pipe(
        map((data) =>
          AdrActions.fetchByIdAdrRecordSuccess({ record: data })
        ),
        catchError((error) => {
          this.notification.error(error.error.message);
          return of(
            AdrActions.fetchByIdAdrRecordFailure({ error }),
          );
        }),
      );
    }),
  )
);


  addAdr$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdrActions.addAdr),
      concatMap(({ newAdr }) =>
        this.adrService.createAdr(newAdr)
          .pipe(
            map((data) => {
              this.notification.success("Saved Successfully");
              return AdrActions.addAdrSuccess(
                {
                  newAdr: data,
                },
              );
            }),
            catchError((error) =>
              of(
                AdrActions.addAdrFailure(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  updateAdr$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdrActions.updateAdr),
      map((action) => action.updateAdr),
      concatMap((updateAdr) =>
        this.adrService
          .updateAdr(updateAdr)
          .pipe(
            map((mapAdr) => {
              console.log('update ', mapAdr)
              this.notification.success("Updated Successfully");
              return AdrActions.updateAdrSuccess(
                {
                  updateAdr: mapAdr,
                },
              );
            }),
            catchError((error) =>
              of(
                AdrActions.updateAdrFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  removeAdr$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdrActions.removeAdr),
      map((action) => action.id),
      concatMap((id) =>
        this.adrService
          .deleteAdr(id)
          .pipe(
            map(() => {
              this.notification.success("Deleted Successfully");
              return AdrActions.removeAdrSuccess(
                { id },
              );
            }),
            catchError((error) =>
              of(
                AdrActions.updateAdrFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AdrStoreReducer.AdrPartialState>,
    private adrService: AdrService,
    private notification: NotificationService,
  ) {}
}